<template>
  <div :class="['grid-list', `grid-list__${children.length}`, css]">
    <component
      :is="item.type"
      :key="item.title"
      v-for="item in children"
      v-bind="item"
    >
    </component>
  </div>
</template>
<script>
export default {
  props: {
    children: {
      type: Array,
      required: true
    },
    css: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="stylus">
.grid-list
  _flex(row, wrap, flex-start, space-between)
  pad('2xl', x)
  & > *
    flex 0 0 33.33%
    border 10px solid #fff
    // cursor pointer
    background-position 90% 90% !important
    background-size auto 57% !important
  &__2 > *
    flex 1
    background-size auto 75% !important
  &__4 > *
    flex 1
    background-size auto 50% !important
    +above(1300px)
      background-size auto 35% !important
      background-position 50% 90% !important
    +above(1400px)
      background-size auto 50% !important
  &__5 > *
  &__7 > *
    &:nth-child(1)
    &:nth-child(2)
      +above(600px)//dubi
        background-size auto 50% !important
        flex 0 0 calc(50% - 10px)
        margin-bottom 20px

  &__7 > *
    &:nth-child(6)
    &:nth-child(7)
      background-size auto 50% !important
      flex 0 0 calc(50% - 10px)
      margin-bottom 20px
    // background-color blue
  +below(1100px)
    // _flex(column, wrap, flex-start, space-between)
    & > *
      flex 0 0 calc(50% - 10px)
      border none
      height 300px
      background-size auto 40% !important
      background-position 95% 90% !important
      margin-bottom 20px
      pad('2xl', y)
      overflow hidden
      +below(815px)
        height 220px
      +portrait()
        min-height 35vh
        pad('2xl', x)
        background-position 90% 90% !important
      +below(1100px, orientation: portrait)
        pad('xl', x)
      +below(600px)
        min-height 38vh
        width 100%
        flex none
        display block
        border none !important
</style>
